export enum PageSubscriptionStatisticsActionTypes {
  GET_PAGE_SUBSCRIPTION_STATISTICS_REQUEST = 'page-subscription-statistics/GET_PAGE_SUBSCRIPTION_STATISTICS_REQUEST',
  GET_PAGE_SUBSCRIPTION_STATISTICS_SUCCESS = 'page-subscription-statistics/GET_PAGE_SUBSCRIPTION_STATISTICS_SUCCESS',
  GET_PAGE_SUBSCRIPTION_STATISTICS_ERROR = 'page-subscription-statistics/GET_PAGE_SUBSCRIPTION_STATISTICS_ERROR',
}
